<div class="wrap">
	<div class="card-button-group">
		<button class="button-general" [disabled]="!hasChanged" (click)="discard()">Discard</button>
		<button class="button-general" [disabled]="checkCommitDisable()" (click)="commit()">Commit</button>
	</div>
	<div class="feed-groups">
		<div class="violation-summary">
			<div class="group-header">Violation Summary</div>
			<div class="group-content code-list">
				<div *ngFor="let item of feedItemList">
					<div class="row-line code-line"  
						(click)="toggleExpand(item)"
						(mouseover)="onMouseoverCode(item.rule.code)"
						(mouseout)="onMouseoutCode()">
						<i class="glyphicons" [ngClass]="{'glyphicons-plus': !item.isExpand, 'glyphicons-minus': item.isExpand}"></i>
						<div class="code-text"><span [title]="item.rule.descLong" [ngClass]="{'item-with-tooltip': item.rule.descLong}">{{item.rule.code}}</span>{{' - ' + item.rule.descShort}}</div>
						<div class="code-count">{{item.count}}</div>
					</div>
					<div class="column-list" *ngIf="item.isExpand">
						<div class="column-line" *ngFor="let col of item.cols" [ngClass]="{'selected-line': selectedColumn?.col === col}" (click)="clickColumn(col, item.rule.code)">
							<div>{{col.label}}</div>
							<div>{{col.count}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="selectedColumn" class="violation-resolution">
			<div class="group-header">Violation Resolution</div>
			<div class="group-content">
				<div class="domain-value-section">
					<div class="cell-item header-cell">Value</div>
					<div class="cell-item" [ngClass]="{'grey-cell': item.value===null}" *ngFor="let item of selectedColumn.currentValueList">
						{{item.value === null ? 'null' : item.value}}
					</div>
				</div>
				<div class="domain-count-section">
					<div class="cell-item header-cell">Count</div>
					<div class="cell-item" *ngFor="let item of selectedColumn.currentValueList">
						<div>{{item.count}}</div>
					</div>
				</div>
				<div class="domain-newvalue-section">
					<div class="cell-item header-cell">New Value</div>
					<div class="cell-item" *ngFor="let item of selectedColumn.currentValueList">
						<ng-container *ngIf="selectedColumn.col.standardName!==nguidStandardName">
							<input *ngIf="!selectedColumn.domain||selectedColumn.domain.type!=='list'"
								name="{{selectedColumn.col.prop}}"
								pattern="{{selectedColumn.domain?.pattern || ''}}"
								appValidateRange="{{selectedColumn.domain?.range || null}}"
								type="{{colType==='date' ? 'date' : 'text'}}"
								[ngClass]="{'invalid-clause': !item.isValid}" 
								[disabled]="checkDisableInput()"
								[(ngModel)]="item.newValue" 
								(ngModelChange)="onEdit()"
								(blur)="checkValidity_input(item)" 
								(keyup.enter)="checkValidity_input(item)">
							<select *ngIf="selectedColumn.domain&&selectedColumn.domain.type==='list'" 
								name="{{selectedColumn.col.prop}}" 
								[ngClass]="{'invalid-clause': !item.isValid}" 
								[(ngModel)]="item.newValue" 
								(ngModelChange)="onEdit();checkValidity_domain(item)">
								<option *ngFor="let val of selectedColumn.domain.list">{{val}}</option>
								<ng-container *ngIf="isCountyCol || isStateCol">
									<option disabled>──────────</option>
									<ng-container *ngIf="isCountyCol">
										<option *ngFor="let val of countyNeighborList" [ngValue]="val.value">{{val.label}}</option>
									</ng-container>
									<ng-container *ngIf="isStateCol">
										<option *ngFor="let val of stateNeighborList" [ngValue]="val">{{val}}</option>
									</ng-container>
								</ng-container>
								<option [ngValue]="null">Null</option>
							</select>
						</ng-container>
						<app-feat-config-nguid *ngIf="selectedColumn.col.standardName===nguidStandardName" [calculateOnly]="true" (onClickCompute)="onComputeNguid($event)"></app-feat-config-nguid>
					</div>
				</div>
				<div class="domain-nag" *ngIf="showNagOperator">
					<div class="cell-item header-cell"></div>
					<div class="cell-item" *ngFor="let item of selectedColumn.currentValueList">
						<i *ngIf="selectedColumn.nagParam" title="Add to nag" class="glyphicons glyphicons-plus" (click)="addToNag(item)"></i>
					</div>
				</div>
			</div>
			<!-- <div *ngIf="selectedColumn.col.standardName===nguidStandardName">
				<app-feat-config-nguid [calculateOnly]="true" (onClickCompute)="onComputeNguid($event)"></app-feat-config-nguid>
			</div> -->
		</div>
	</div>
</div>